import { functions } from '../../modules/functions'

export module SliderModule {
  export class Service {
    constructor(language?: string) {
      document.addEventListener('readCompleteAction', () => {
        Service.slider();
      });
    }

    public static slider() {
      let $windowWidth = functions.getWindowWidth();
      let $targets = document.querySelectorAll('.js__swiper');
      if ($targets) {
        $targets.forEach($target => {
          let $children = $target.children;
          if ($children.length && document.defaultView) {
            let $targetItemWidth = parseFloat(document.defaultView.getComputedStyle($children[0], null).inlineSize);
            const $childrenLength = $children.length;
            while ($windowWidth > ($children.length * $targetItemWidth)) {
              for (let $i = 0; $childrenLength > $i; $i++) {
                let $child = $children[$i] as HTMLElement;
                let $targetItemClone = $child.cloneNode();
                $target.appendChild($targetItemClone);
              }
            }
            $target.innerHTML = '<div class="js__swiperInner">' + $target.innerHTML + $target.innerHTML + '</div>';
          }
        });
      }
    }
  }
}